<nav class="navbar navbar-expand-sm navbar-light row" style="background-color: #0D4F8B;">
    <div class="col-7 p-0">
        <div class="LogoContainer">
            <img src="assets/images/AICTELogo.png" alt="Logo" class="logoImg">
            <img src="assets/images/SLALogo.png" alt="Logo" class="logoImg">
            <img src="assets/images/Parakhlogo.png" alt="Logo" class="logoImg" style="height: 47px;">
        </div>
    </div>

    <div class="col-5">
        <div class="navbar-nav float-right">
            <div>
                <a (click)="goToHome()" class="nav-link" style="color: white; font-size: 16px; padding-top: 12px; cursor: pointer;"><strong>Home</strong></a>
            </div>
            <!-- <button class="nav-item m-2 grievanceButton" *ngIf="loggedIn" mat-raised-button (click)="grievance()"><mat-icon style="color:#0d4f8b">contact_support</mat-icon>Grievances</button>
            <button mat-icon-button [matMenuTriggerFor]="userMenu" #userMenuTrigger="matMenuTrigger" style="margin-right: 15px;">
                        <mat-icon style="font-size: 35px;padding-top: 7px;color: #fff;">account_circle</mat-icon>
                    </button>
            -->
            <button class="nav-item m-2 logoutButton" mat-raised-button (click)="logout($event)">Logout</button>
        </div>
    </div>
</nav>
<div class="container flex-wrapper">
    <mat-card class="mat-elevation-z8 m-2">
        <mat-card-header class="text-center card-header linkBgColor">
            <h5>Reset Password</h5>
        </mat-card-header>
        <div class="m-4" id="form">
            <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit(resetPasswordForm.value)">
                <div class="row">
                    <div class="col-lg-6 col-sm-12">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Current Password</mat-label>
                            <mat-icon matPrefix class="mat-icon-sm mb-2 mr-2 secondary-text-color">lock
                            </mat-icon>
                            <input autocomplete="new-password" matInput type="password" placeholder="Current Password" formControlName="current_password" maxlength="30">
                            <mat-error *ngIf="resetPasswordForm.controls.current_password.errors">
                                Required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-sm-12">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>New Password</mat-label>
                            <mat-icon matPrefix class="mat-icon-sm mb-2 mr-2 secondary-text-color">lock
                            </mat-icon>
                            <input autocomplete="new-password" matInput type="password" placeholder="New Password" formControlName="new_password" maxlength="30">
                            <mat-error *ngIf="resetPasswordForm.controls.new_password.errors?.required">Required
                            </mat-error>
                            <mat-error *ngIf="resetPasswordForm.controls.new_password.errors?.minlength">The password must be at least 8 characters long.
                            </mat-error>
                            <mat-error class="mb-2" *ngIf="resetPasswordForm.controls.new_password.errors?.pattern">It must contain atleast 1 lowercase, 1 uppercase, 1 number and 1 special character each.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-6 col-sm-12">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Confirm New Password</mat-label>
                            <mat-icon matPrefix class="mat-icon-sm mb-2 mr-2 secondary-text-color">lock
                            </mat-icon>
                            <input autocomplete="new-password" matInput type="password" placeholder="Confirm New Password" formControlName="new_password_confirmation" maxlength="30">
                            <mat-error *ngIf="resetPasswordForm.controls.new_password_confirmation.errors">Required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <button class="float-right" mat-raised-button type="submit" color="primary">Save</button>
            </form>
        </div>
    </mat-card>
</div>

<mat-toolbar style="background-color: #0D4F8B;">
    <div class="foot py-2 w-100" style="text-align: center !important; color: white;">
        <span>Copyrights © AICTE, Nelson Mandela Marg, Vasant Kunj, New Delhi -110070.</span>
    </div>
</mat-toolbar>

<style>
    mat-form-field {
        padding: 5px;
    }
</style>